<template>
  <div class="uk-width-expand@m">
    <div class="bb-options">
      <div class="uk-child-width-1-2" uk-grid>
        <div>
          <div class="bb-option">
            <p class="label">
              Left Cabinet Size: <InfoIcon slug="cabinets-left-cabinet" />
            </p>
            <div class="input-radios">
              <div class="input">
                <label
                  ><input
                    type="radio"
                    class="uk-radio"
                    name="cabinet-size"
                    value="none"
                    v-model="cabinet_size"
                  />
                  No Cabinet</label
                >
              </div>
              <div class="input"
                v-for="size in size_options"
                :key="size">
                <label
                  ><input
                    type="radio"
                    class="uk-radio"
                    name="cabinet-size"
                    :value="size"
                    v-model="cabinet_size"
                  />
                  {{ size }}" Cabinet</label
                >
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="bb-option">
            <p class="label">
              Additions:
            </p>
            <div class="input-radios">
              <div class="input">
                <label
                  ><input type="checkbox" class="uk-checkbox" v-model="cabinet_night_tray" /> Slide-out Night Tray <InfoIcon slug="slideout-tray" />
                </label>
              </div>
              <div class="input" v-if="allowGlassDoors">
                <label
                  ><input type="checkbox" class="uk-checkbox" v-model="cabinet_glass_doors" /> Glass Door (standard clear glass only)</label>
              </div>
              <div class="input" v-if="cabinet_glass_doors == true">
                <label
                  ><input type="checkbox" class="uk-checkbox" v-model="cabinet_glass_shelves" /> Glass Shelves</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- cabinet options -->
      <div class="bb-option" v-if="filtered_cabinets.length > 0">
        <p class="label">Left Cabinet Style:</p>
        <div class="input-radios">
          <div class="input"
            v-for="(cabinet,index) in filtered_cabinets"
            :key="index">
            <label
              ><input
                type="radio"
                class="uk-radio"
                :ref="`cabinet-${index}`"
                name="cabinet-style"
                :value="index"
                v-model="cabinet_style"
              />
              {{ cabinet.cabinet_type.name }} (+${{ cabinetPrice(cabinet) }})</label
            >
          </div>
        </div>
      </div>
    </div>
    <NextButtons
      prev_route="additions"
      next_route="right_cabinet" />
    <AlertModal
      :modal_id="alert.id"
      :alert_copy="alert.copy"
      :alert_title="alert.title"
      @cancel="onCancelDepthChange"
      @agree="onAgreeDepthChange" />
  </div>
</template>

<script>
import NextButtons from "../components/NextButtons.vue";
import {mapState} from 'vuex';
import InfoIcon from '../components/InfoIcon.vue';
import AlertModal from '../components/AlertModal.vue';

export default {
  name: "cabinets-view",
  components: {
    NextButtons,
    InfoIcon,
    AlertModal
  },
  data() {
    return {
      cabinet_size : "none",
      cabinet_style : null,
      filtered_cabinets: [],
      alert : {
        id : "left_depth_modal",
        title : "Headboard Option Change Required",
        copy : "This wardrobe can only be selected with the \"Deep\" headboard option. Would you like to switch to the deep headboard?"
      },
      old_cabinet_index : null,
      new_cabinet_index : null
    };
  },
  mounted(){
    if(this.selected_cabinet_size != this.cabinet_size ) this.cabinet_size = this.selected_cabinet_size;
    if(this.selected_cabinet_style != this.cabinet_style ) this.cabinet_style = this.selected_cabinet_style;
  },
  methods : {
    showDepthAlertModal(){
      //eslint-disable-next-line
      UIkit.modal(document.getElementById(this.alert.id)).show();
    },
    /**
     * check that cabinet doesn't need a Deep Depth.
     * @param  {[type]} new_index index of new cabinet wanted
     * @param  {[type]} old_index previous selection
     * @return {[type]}           [description]
     */
    checkWallbedDepth(new_index, old_index){
      const newCabinet = this.filtered_cabinets[new_index];
      // if no headboard selected
      // or no depths were specified for the cabinet
      if(this.selected_headboard == null || newCabinet.cabinet_type.depths.length == 0){
        this.setSelectedCabinet();
        return;
      }
      // loop through cabinet depths and see what is required.
      let found = false;
      for (let i in newCabinet.cabinet_type.depths){
        const depth = newCabinet.cabinet_type.depths[i];
        if(depth.name == this.selected_headboard.name){
          found = true;
          break;
        }
      }
      // if no match
      if(!found){
        this.old_cabinet_index = old_index;
        this.new_cabinet_index = new_index;
        this.showDepthAlertModal();
      }else{
        this.setSelectedCabinet();
      }
    },
    /**
     * save style and send current type to store.
     * @param {[type]} index [description]
     */
    setSelectedCabinet(){
      // save selected style.
      this.$store.commit('setSelectedCabinetStyle',{side : 'left' , style : this.cabinet_style});
      // handle selection of cabinet
      this.checkSelectedCabinet();
    },
    /**
     * user doesn't want to change the headboard depth
     * revert back to previous selection
     * trigger click on previous selection then reset old index
     * @return {[type]} [description]
     */
    onCancelDepthChange(){
      if(this.old_cabinet_index != null){
        this.$refs[`cabinet-${this.old_cabinet_index}`][0].click();
      }else{
        this.$refs[`cabinet-${this.new_cabinet_index}`][0].checked = false;
      }
    },
    /**
     * set selected depth to "Deep"
     * @return {[type]} [description]
     */
    onAgreeDepthChange(){
      // set depth to be deep.
      for (let i in this.depth_prices){
        const depth = this.depth_prices[i];
        if(depth.name == "Deep"){
          this.$store.commit("setSelectedHeadboard",depth);
          break;
        }
      }
      this.setSelectedCabinet();
    },
    /**
     * check the selected wood and get price
     * @param  {[type]} cabinet [description]
     * @return {[type]}         [description]
     */
    cabinetPrice(cabinet){
      const width = `${this.cabinet_size}.00`;
      const woodID = this.selected_wood.id;
      let price = null;
      // loop through all pricing
      for(let i in cabinet.cabinet_type.prices){
        const row = cabinet.cabinet_type.prices[i];
        if(row.width == width){
          for(let w in row.woods){
            if(woodID == row.woods[w].id){
              price = row;
              break;
            }
          }
        }
        if(price != null) break;
      }

      let finalPrice = parseFloat(price.price);
      if(this.selected_finish != null){
        let wallbedUpcharge = this.selected_finish.grade.wallbed_upcharge;
        if(wallbedUpcharge != null){
          finalPrice = finalPrice + parseFloat(wallbedUpcharge);
        }
      }

      // use this price
      return this.$options.filters.wholeNumber(finalPrice);
    },

    /**
     * check selected index and send selected cabinet to store
     * @return {[type]} [description]
     */
    checkSelectedCabinet(){
      let selected = null;
      // if actually selected find object in array
      if(this.cabinet_style != "none"){
        selected = this.filtered_cabinets[this.cabinet_style];
      }
      this.$store.commit('setSelectedCabinetLeft', selected);
    }
  },
  computed : {
    /**
     * check wither the cabinet type has the ability to have glass doors
     * @return {[type]} [description]
     */
    allowGlassDoors(){
      if(this.selected_cabinet == null) return false;
      return this.selected_cabinet.cabinet_type.doors === 1;
    },
    /**
     * map wether the cabinet has a slideout night tray to store
     * @type {Object}
     */
    cabinet_night_tray: {
      get() { return this.$store.state.left_cabinet_night_tray },
      set(value){ this.$store.commit('updateCabinetNightTray',{value : value, side : 'left'}) }
    },
    /**
     * map whether the cabinet has glass doors to store
     * @type {Object}
     */
    cabinet_glass_doors : {
      get() { return this.$store.state.left_cabinet_glass_doors },
      set(value){ this.$store.commit('updateCabinetGlassDoors',{value : value, side : 'left'}) }
    },
    /**
     * map wether the cabinet has glass shelves to store
     * @type {Object}
     */
    cabinet_glass_shelves : {
      get() { return this.$store.state.left_cabinet_glass_shelves },
      set(value){ this.$store.commit('updateCabinetGlassShelves',{value : value, side : 'left'}) }
    },
    /**
     * standard store mapping properties
     * @param  {[type]} state [description]
     * @return {[type]}       [description]
     */
    ...mapState({
      cabinet_sizes : state => state.cabinet_sizes,
      selected_wood : state => state.selected_wood,
      selected_finish : state => state.selected_finish,
      selected_cabinet_size : state => state.selected_left_cabinet_size,
      selected_cabinet_style : state => state.selected_left_cabinet_style,
      selected_cabinet : state => state.selected_cabinet_left,
      selected_headboard : state => state.selected_headboard,
      depth_prices : state => state.depth_prices,
      size_options :  state => state.cabinet_size_options
    })
  },
  watch : {
    /**
     * if the cabinet doesn't allow for doors
     * make sure glass doors and shelves are removed.
     * @return {[type]} [description]
     */
    selected_cabinet() {
      if(this.selected_cabinet != null){
        if(this.selected_cabinet.cabinet_type.doors === 0){
          this.cabinet_glass_doors = false;
          this.cabinet_glass_shelves = false;
        }
        //this.checkWallbedDepth(null,null);
      }
    },
    /**
     * pick correct list of cabinets based on selected size
     * if none clear seleced
     * @return {[type]} [description]
     */
    cabinet_size(){
      this.$store.commit('setSelectedCabinetSize',{side : 'left' , size : this.cabinet_size});
      switch(this.cabinet_size){
        case "none":
          this.filtered_cabinets = [];
          this.cabinet_style = null;
        break;
        default:
          this.filtered_cabinets = this.cabinet_sizes[this.cabinet_size];
        break;
      }
      this.checkSelectedCabinet();
    },
    /**
     * save selected style in store
     * @return {[type]} [description]
     */
    cabinet_style(newVal,oldVal){
      //eslint-disable-next-line
      //console.log(`new ${newVal} old ${oldVal}`);
      this.checkWallbedDepth(newVal,oldVal);
    },
  }
};
</script>